<!-- <main  cdkDropList cdkDropListOrientation="vertical" (cdkDropListDropped)="drop($event)">

    <mat-list role="list">
        <mat-list-item role="listitem" class="content-item" cdkDrag *ngFor="let item of items; let i = index">
            <div style="width: fit-content !important;">
                <mat-icon>{{ item.type | typeIcon }}</mat-icon>
              </div>
         <h1>     {{item.name}}</h1>
         <p>Dossier</p>

        </mat-list-item>

      </mat-list>


</main> -->

<ng-container *ngIf="repairInProgress || isWorking">
  <div class="loading">
    <img src="assets/ui/loading.svg" />
  </div>
</ng-container>

<ng-container *ngIf="displayRepair">
  <button class="card-button" mat-flat-button color="accent" (click)="repairAllMediaFromCurrentContent()">{{'repairCurrentFolder' | translation}}</button>
</ng-container>

<main *ngIf="items" #rowLayout cdkDropListGroup>
  <!-- Based on the width of template reference #rowLayout' and item box width,
       columns per row can be calculated and a items table matrix is initialized-->
  <!--   -->
  <div fxLayout="row"
       *ngFor="let itemsRow of getItemsTable(rowLayout); let rowIndex = index"
       cdkDropList
       cdkDropListOrientation="horizontal"
       [cdkDropListData]="itemsRow"
       (cdkDropListDropped)="reorderDroppedItem($event)">
    <!-- Component.reorderDroppedItem():
         reorders table/view model, update input model, and resize table matrix-->

    <div class="contentItem" [ngClass]="{'defaultSVG': item?.asBackground }" [matMenuTriggerFor]="menuEditContent" *ngFor="let item of itemsRow; let i = index" cdkDrag>
      <div class="contentHeader">
        <mat-icon *ngIf="!item.mediaOptions?.customBehavior?.enable || item.mediaOptions?.type != 'folder'; else customBehaviorIcon">{{ item.type | typeIcon }}</mat-icon>
        <ng-template #customBehaviorIcon>
          <mat-icon>folder_special</mat-icon>
        </ng-template>
        <div class="drag-placeholder" *cdkDragPlaceholder></div>
        <div fxLayoutAlign="center center" class="item-box">{{ item.displayName }}</div>
      </div>
      <div class="thumbnailOverlay" *ngIf="item.mediaOptions != undefined && item.mediaOptions.thumbnail != undefined&& item.mediaOptions.thumbnail.url != null && item.mediaOptions.thumbnail.url.length > 0">
        <img [src]="item.mediaOptions.thumbnail.url" />
      </div>
      <div class="stateElement" *ngIf="item.mediaOptions != undefined && !item.mediaOptions.active">
        <mat-icon>visibility_off</mat-icon>
      </div>

      <div class="stateElement" *ngIf="item.mediaOptions != undefined && !calendarIsOk(item)">
        <mat-icon>calendar_today</mat-icon>
      </div>

      <div class="stateElement" *ngIf="item.mediaOptions != undefined && item.mediaOptions.lock">
        <mat-icon>lock</mat-icon>
      </div>
      <div class="contentDisplay">

        <p class="textNoPicture"
           *ngIf="!getFileUrl(item) && (item.mediaOptions != undefined && !item.mediaOptions.thumbnail)">
          {{'noPreview' | translation}}
        </p>





        <div fxLayout="row wrap" class="content-image-wrapper"
             *ngIf="item.mediaOptions != undefined && item.mediaOptions.thumbnail && item.type == 'folder'">
          <img [src]="getFileUrl(item)"
               alt="Aucun aperçu" />
        </div>
        <div fxLayout="row w-100" class="content-image-wrapper"
             *ngIf="item.mediaOptions != undefined  && (item.type == 'file' ||item.type == 'quiz')">
          <img [src]="getFileUrl(item)" [hidden]="!getFileUrl(item)" alt="Aucun aperçu" />



        </div>
        <div fxLayout="row w-100" class="content-image-wrapper"
             *ngIf="item.mediaOptions != undefined  && (item.type == 'web')">
          <img [src]="getFileUrl(item)" [hidden]="!getFileUrl(item)" alt="Aucun aperçu" />
        </div>
      </div>
      <mat-menu #menuEditContent="matMenu">

        <button *ngIf="item.mediaOptions != undefined && item.mediaOptions.active"
                (click)="setElementVisibility(item)" mat-menu-item>
          <mat-icon>visibility_off</mat-icon>
          {{'disable' | translation}}
        </button>
        <button *ngIf="item.mediaOptions != undefined && !item.mediaOptions.active"
                (click)="setElementVisibility(item)" mat-menu-item>

          <mat-icon>visibility_on</mat-icon>
          {{'activate' | translation}}
        </button>


        <button *ngIf="item.mediaOptions != undefined && !item.mediaOptions.lock" (click)="setElementLock(item)"
                mat-menu-item>
          <mat-icon>lock</mat-icon>
          {{'lock' | translation}}
        </button>
        <button *ngIf="item.mediaOptions != undefined && item.mediaOptions.lock" (click)="setElementLock(item)"
                mat-menu-item>
          <mat-icon>lock_open</mat-icon>
          {{'unlock' | translation}}
        </button>
        <button *ngIf="item.mediaOptions != undefined" (click)="managePeriod(item)"
                mat-menu-item>
          <mat-icon>calendar_today</mat-icon>
          {{'periodManager' | translation}}
        </button>

        <button *ngIf="item.mediaOptions != undefined && item.name.includes('svg') && selectedFolder.mediaOptions?.customBehavior.dataType == 'generic'" (click)="setSVGContent(item)"
                mat-menu-item>
          <mat-icon>settings</mat-icon>
          {{'contentManager' | translation}}
        </button>


        <button *ngIf="item.mediaOptions != undefined && item.name.includes('pdf') && _shareVar.checkAppVersion('1.21.8', 'media')" [matMenuTriggerFor]="customPDF" mat-menu-item>
          <mat-icon>pdf</mat-icon>
          {{'pdfSettings' | translation}}
        </button>
        <!-- SET CUSTOM BEHAVIOUR -->


        <button *ngIf="item.mediaOptions != undefined && item.mediaOptions.type == 'folder' && (checkIfAvailable('michelin') || checkIfAvailable('ofb'))" [matMenuTriggerFor]="customMediaBehavior"
                mat-menu-item>
          <mat-icon>settings</mat-icon>
          {{'customMediaBehavior' | translation}}
        </button>

        <mat-menu #customPDF>
          <button mat-menu-item (click)="setPdfDisplay(item, 'default')">
            <mat-icon></mat-icon>
            1 page
            <mat-icon *ngIf=" item.mediaOptions?.pdfDisplay == 'default'  || !item.mediaOptions?.pdfDisplay">check</mat-icon>
          </button>

          <button mat-menu-item (click)="setPdfDisplay(item, 'double')">
            <mat-icon></mat-icon>
            2 pages
            <mat-icon *ngIf=" item.mediaOptions?.pdfDisplay == 'double'">check</mat-icon>
          </button>
          <button mat-menu-item (click)="setPdfDisplay(item, 'soloScroll')">
            <mat-icon></mat-icon>
            Liste - 1 page
            <mat-icon *ngIf=" item.mediaOptions?.pdfDisplay == 'soloScroll'">check</mat-icon>
          </button>
          <button mat-menu-item (click)="setPdfDisplay(item, 'doubleScroll')">
            <mat-icon></mat-icon>
            Liste - 2 pages
            <mat-icon *ngIf=" item.mediaOptions?.pdfDisplay == 'doubleScroll'">check</mat-icon>
          </button>
          <!--     <button mat-menu-item (click)="setPdfDisplay(item, 'book')">
             <mat-icon></mat-icon>
             Livre
             <mat-icon *ngIf=" item.mediaOptions?.pdfDisplay == 'book'">check</mat-icon>
           </button>-->
        </mat-menu>

        <mat-menu #customMediaBehavior>
          <button mat-menu-item (click)="setElementCustomBehavior(item, 'contentOFB', 'module')" *ngIf="checkIfAvailable('ofb')">
            <mat-icon></mat-icon>
            CUSTOM OFB
            <mat-icon *ngIf=" item.mediaOptions?.customBehavior?.enable &&
                      item.mediaOptions.customBehavior?.behaviorType == 'contentOFB' &&
                      item.mediaOptions?.customBehavior?.dataType == 'module'">check</mat-icon>
          </button>
          <button mat-menu-item (click)="setElementCustomBehavior(item, 'contentSOGEA', 'module')" *ngIf="checkIfAvailable('sogea')">
            <mat-icon></mat-icon>
            CUSTOM SOGEA
            <mat-icon *ngIf=" item.mediaOptions?.customBehavior?.enable &&
                      item.mediaOptions.customBehavior?.behaviorType == 'contentSOGEA' &&
                      item.mediaOptions?.customBehavior?.dataType == 'module'">check</mat-icon>
          </button>
          <button mat-menu-item (click)="setElementCustomBehavior(item, 'map', 'xls')">
            <mat-icon>picture_as_pdf</mat-icon>
            {{ 'customMediaBehaviorXLS' | translation}}
            <mat-icon *ngIf=" item.mediaOptions?.customBehavior?.enable &&
                      item.mediaOptions.customBehavior?.behaviorType == 'map' &&
                      item.mediaOptions?.customBehavior?.dataType == 'xls'">check</mat-icon>
          </button>
          <button mat-menu-item (click)="setElementCustomBehavior(item, 'map', 'pdf')">
            <mat-icon>picture_as_pdf</mat-icon>
            {{ 'customMediaBehaviorPDF' | translation}}
            <mat-icon *ngIf=" item.mediaOptions?.customBehavior?.enable &&
                      item.mediaOptions.customBehavior?.behaviorType == 'map' &&
                      item.mediaOptions?.customBehavior?.dataType == 'pdf'">check</mat-icon>
          </button>
          <button mat-menu-item (click)="setElementCustomBehavior(item, 'map', 'generic')" *ngIf="checkIfAvailable('ofb') || _shareVar.checkAppVersion('1.21.6', 'media')">
            <mat-icon>picture_as_pdf</mat-icon>
            {{ 'customMediaBehaviorGeneric' | translation}}
            <mat-icon *ngIf=" item.mediaOptions?.customBehavior?.enable &&
                     item.mediaOptions.customBehavior?.behaviorType == 'map' &&
                     item.mediaOptions?.customBehavior?.dataType == 'generic'">check</mat-icon>
          </button>
          <button mat-menu-item (click)="setElementCustomBehavior(item, 'email', 'email')">
            <mat-icon> email</mat-icon>
            {{ 'customMediaBehaviorEmail' | translation}}
            <mat-icon *ngIf=" item.mediaOptions?.customBehavior?.enable &&
                      item.mediaOptions?.customBehavior?.behaviorType == 'email' &&
                      item.mediaOptions?.customBehavior?.dataType == 'email'">check</mat-icon>
          </button>
          <button mat-menu-item (click)="setElementCustomBehavior(item, 'map', 'video')">
            <mat-icon>video_library</mat-icon>
            {{ 'customMediaBehaviorVideo' | translation}}
            <mat-icon *ngIf=" item.mediaOptions?.customBehavior?.enable &&
                      item.mediaOptions?.customBehavior?.behaviorType == 'map' &&
                      item.mediaOptions?.customBehavior?.dataType == 'video'">check</mat-icon>
          </button>
        </mat-menu>

        <!---->










        <button *ngIf="item.mediaOptions != undefined && _firebase.user.role == 'mainuser' && (customLoad == 'malta' || customLoad == 'dev')" (click)="assignToSpecUser(item)"
                mat-menu-item>
          <mat-icon>supervised_user_circle</mat-icon>
          {{'assign' | translation}}
        </button>
        <button mat-menu-item *ngIf="(canAddThumbnail(item) || item.type =='quiz') && item.mediaOptions && item.mediaOptions.thumbnail == undefined || (item.mediaOptions != undefined && item.mediaOptions.thumbnail != undefined && item.mediaOptions.thumbnail.url.length == 0)"
                (click)="uploadThumbnail(item)">
          <mat-icon>image</mat-icon>
          {{'addThumbnail' | translation}}
        </button>
        <button mat-menu-item *ngIf="item.mediaOptions != undefined && item.mediaOptions.thumbnail != undefined && item.mediaOptions.thumbnail.url != null && item.mediaOptions.thumbnail.url.length > 0"
                (click)="deleteThumbnail(item)">
          <mat-icon>image</mat-icon>
          {{'deleteThumbnail' | translation}}
        </button>
        <button mat-menu-item (click)="manageTags(item)">
          <mat-icon>folder</mat-icon>
          {{'manageTag' | translation}}
        </button>

        <button mat-menu-item (click)="moveTo(item.id)">
          <mat-icon>folder</mat-icon>
          {{'moveTo' | translation }}
        </button>

        <button *ngIf="item.type != 'web'" mat-menu-item (click)="rename(item)">
          <mat-icon>folder</mat-icon>
          {{'rename' | translation }}
        </button>

        <button *ngIf="!item.mediaOptions" mat-menu-item (click)="repairMedia(item)">
          <mat-icon>build</mat-icon>
          {{'repairMedia' | translation}}
        </button>

        <button mat-menu-item (click)="deleteMedia(item)">
          <mat-icon color="warn">delete</mat-icon>
          {{'delete' | translation}}
        </button>
      </mat-menu>

      <div *ngIf="showSVGTooltip && item?.asBackground" class="svgItemTitleBottom">


        <p>{{'background2' |translation}}</p>

      </div>
    </div>


  </div>


  <div *ngIf="items.length == 0">
    <p>{{'noContent' | translation}}</p>
  </div>


  <div class="genericInteractTooltip">
    <ng-container *ngIf="showSVGTooltip">
      <div id="icon">
        <mat-icon>info</mat-icon>
      </div>
      <div>
        <p>
          Importez un fichier SVG afin de créer une page interactive 100% personnalisable.
        </p>
        <p>Le fichier SVG situé en première position définit l’arrière plan de la page.</p>

      </div>

    </ng-container>
  </div>

</main>

